<template>
  <lf-dropdown
    :value="selectedOwnerId"
    :placeholder="$t('COMMON.OWNER')"
    :options="ownerDropdownOptions"
    name="ownerDropdown"
    data-cy="owner-dropdown"
    class="w-full"
    @change="(ownerId) => (selectedOwnerId = String(ownerId))"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";

import { getIndividualName } from "@/helpers/common";
import { formatPercentage } from "@/helpers/formatting";
import { useDealOwners } from "@/hooks/deals";

import LfDropdown from "@/components/ui/inputs/LfDropdown.vue";

const selectedOwnerId = defineModel<string>("selectedOwnerId", {
  required: true,
});

const dealOwners = useDealOwners();

const uniqueOwners = computed(() => {
  const owners = dealOwners.value || [];
  return owners.filter(
    (owner, index, self) => index === self.findIndex((o) => o.id === owner.id)
  );
});

const ownerDropdownOptions = computed(() => {
  const options: Record<string | number, string> = {};
  uniqueOwners.value.forEach((owner, index) => {
    const name = getIndividualName(owner, index);
    const percentage = owner.ownership_percentage
      ? ` (${formatPercentage(Number(owner.ownership_percentage))})`
      : "";
    const primaryIndicator = owner.is_primary ? " ★" : "";
    options[owner.id] = `${name}${percentage}${primaryIndicator}`;
  });
  return options;
});

defineExpose({
  uniqueOwners,
  getFirstOwnerId: () =>
    uniqueOwners.value.length > 0 ? String(uniqueOwners.value[0].id) : "",
});
</script>
